<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :disabled="!$auth.policies['update-student-class']">
          <v-list-item-title style="cursor: pointer" @click="changeClass = !changeClass">Chuyển lớp</v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="!$auth.policies['update-student-status']">
          <v-list-item-title style="cursor: pointer" @click="changeStatus = !changeStatus">
            Chuyển trạng thái
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <ChangeClassDialog :item="selectedStudent" :state="changeClass" @success="$emit('success')" />
    <ChangeStatusDialog :item="selectedStudent" :state="changeStatus" @success="$emit('success')" />
  </div>
</template>

<script>
import ChangeClassDialog from '@/modules/student/ChangeClassDialog.vue'
import ChangeStatusDialog from '@/modules/student/ChangeStatusDialog'

export default {
  components: {
    ChangeClassDialog,
    ChangeStatusDialog
  },
  props: {
    selectedStudent: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      changeClass: false,
      changeStatus: false
    }
  }
}
</script>
